export default __webpack_public_path__ + "static/media/congrats-status@2x.6fb262c6.png";